export const roundToReadability = (
  value: number,
  readability: number,
  resolution: number
): number => {
  const decimalPlaces = resolution;
  const scale = Math.pow(10, decimalPlaces);

  const valueScaled = Math.round(value * scale);
  const readabilityScaled = Math.round(readability * scale);

  const rounded =
    Math.round(valueScaled / readabilityScaled) * readabilityScaled;
  return parseFloat((rounded / scale).toFixed(decimalPlaces));
};
